import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import NewOrder from "@/pages/NewOrder";
import Orders from "@/pages/Orders";
import OrderDetail from "@/pages/OrderDetail";
import OrderEdit from "@/pages/OrderEdit";
import BarcodeGenerator from "@/pages/BarcodeGenerator";
import Reports from "@/pages/Reports";
import AdminUsers from "@/pages/AdminUsers";
import Masters from "@/pages/Masters";

function AppRouter() {
  const location = useLocation();
  // Synchronous check for OAuth return — prevents race condition with ProtectedRoute.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/orders/new" element={<NewOrder />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/orders/:id" element={<OrderDetail />} />
        <Route path="/orders/:id/edit" element={<OrderEdit />} />
        <Route path="/barcodes" element={<BarcodeGenerator />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/masters" element={<Masters />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              border: "2px solid #0A0A0A",
              borderRadius: 0,
              boxShadow: "4px 4px 0 0 #0A0A0A",
              fontFamily: "IBM Plex Mono, monospace",
            },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}
